import { Button, Typography } from '@eye-able/ui';
import { useEffect } from 'react';
import { useBootScreen } from '@hooks/useBootScreen';
import { Link } from 'react-router-dom';
import { T } from '@/i18n/T';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export default function NotFoundPage() {
  const { t } = useInlineTranslation();
  const { disableBootScreen } = useBootScreen();

  useEffect(() => {
    disableBootScreen();
  }, [disableBootScreen]);

  return (
    <div className='eye:flex eye:flex-col eye:items-center eye:gap-3xs eye:my-xl eye:text-center'>
      <Typography variant='headline-l'>404</Typography>
      <Typography variant='body-l'>
        <T k='pageNotFound' />
      </Typography>
      <Button asChild>
        <Link to='/'>{t('backToHome')}</Link>
      </Button>
    </div>
  );
}
